var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card",
    class: _vm.$style.container
  }, [_vm._m(0), _c('a-form', {
    staticClass: "mb-4",
    attrs: {
      "form": _vm.form
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['email', {
        rules: [{
          required: true,
          message: 'Please type your email address!'
        }]
      }],
      expression: "[\n            'email',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please type your email address!',\n                },\n              ],\n            },\n          ]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "Email address"
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('a-button', {
    staticClass: "text-center w-100",
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.requestResetPassword($event);
      }
    }
  }, [_c('strong', [_vm._v("Request password reset")])])], 1), _c('router-link', {
    staticClass: "kit__utils__link font-size-16",
    attrs: {
      "to": "/auth/login"
    }
  }, [_c('i', {
    staticClass: "fe fe-arrow-left mr-1 align-middle"
  }), _vm._v(" Back to SignIn ")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-dark font-size-24 mb-4"
  }, [_c('strong', [_vm._v("Reset password")])]);
}]

export { render, staticRenderFns }